export default {"src":"/_next/static/media/e.b15c5340.svg","height":24,"width":22,"blurWidth":0,"blurHeight":0};